import React, { memo } from 'react'
import { Flex } from 'pcln-design-system'
import ChildAgeSelect from '../ChildAgeSelect'
import TravelerLineItem from '../TravelerLineItem'
import { ChildrenAges } from '../types'
import Divider from '../Divider'

export interface IChildrenLineItem {
  ages?: ChildrenAges
  ageSelectEnabled?: boolean
  className?: string
  count?: number
  isChildAgeSeti?: boolean
  max?: number
  onAgeChange: (index: number, value: string) => void
  onChange: (count: number) => void
  subLabel: string
}

const ChildrenLineItem = ({
  ages,
  ageSelectEnabled,
  className,
  count,
  isChildAgeSeti,
  max,
  onAgeChange,
  onChange,
  subLabel,
}: IChildrenLineItem) => {
  const selects = Array(count).fill(0)
  return (
    <Flex flexDirection='column' width={1}>
      <TravelerLineItem
        className={className}
        label='Children'
        subLabel={!ageSelectEnabled && subLabel}
        min={0}
        max={max}
        count={count}
        onChange={onChange}
      />
      {ageSelectEnabled &&
        selects.map((value, index) => (
          <>
            <ChildAgeSelect
              key={index}
              index={index}
              value={ages && ages[index]}
              onChange={onAgeChange}
              isChildAgeSeti={isChildAgeSeti}
            />
            {index !== selects.length - 1 && <Divider />}
          </>
        ))}
    </Flex>
  )
}

export default memo(ChildrenLineItem)
